module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'akhgwrcz',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
